import React, { useEffect } from 'react';

import AuthenticatedRoute from './AuthenticatedRoute';
import { useGetProsumerProfile, useTeamsProfile } from '../../hooks/use-hydra';
import { ROUTES } from '../../routing';
import { useHistory } from 'react-router-dom';
import FullScreenLoader from '../Loader/FullScreenLoader';
const ProsumerLockedRoute = ({
  path,
  children,
  ...rest
}: {
  path: string;
  children: React.ReactNode;
  exact?: boolean;
}) => {
  const { value: prosumerProfile, loading } = useGetProsumerProfile();
  const { value: teamsProfile } = useTeamsProfile();

  const hasTeamsProfile = teamsProfile?.hasProfile;
  const history = useHistory();

  // TODO - get rid of this once we split projects into teams and prosumers
  // added this as a hack to enable users with a non-pro prosumer profile and a teams profile to access projects
  const shouldSkipProjectRedirect =
    window.location.pathname.includes('/projects') && hasTeamsProfile;

  useEffect(() => {
    if (
      prosumerProfile &&
      !prosumerProfile.learnMode.hasAccess &&
      !window.location.pathname.includes(
        ROUTES.PROSUMER.PAYMENT_CALLBACK.getPath()
      ) &&
      !window.location.pathname.includes(
        ROUTES.PROSUMER.PLAN_UPSELL.getPath()
      ) &&
      !window.location.pathname.includes(
        ROUTES.PROSUMER.BENEFITS_UPSELL.getPath()
      ) &&
      !shouldSkipProjectRedirect
    ) {
      history.push(ROUTES.PROSUMER.PLAN_UPSELL.getPath());
    }
  }, [prosumerProfile, history, shouldSkipProjectRedirect]);

  if (loading) {
    return <FullScreenLoader />;
  }

  return (
    <AuthenticatedRoute path={path} {...rest}>
      {children}
    </AuthenticatedRoute>
  );
};

export default ProsumerLockedRoute;
